import type { MutationKey, UseMutationOptions } from '@tanstack/react-query';
import { wishlistLogin, WishlistLoginParams, wishlistLogout, WishlistLogoutParams } from './wishlist.api';
import type { OptionalMutationOptions, QueryApiOptions } from '../../types/types';

export const wishlistMutationKeys = {
  all: () => ['wishlist'] as MutationKey,
  login: () => [...wishlistMutationKeys.all(), 'login'] as MutationKey,
  logout: () => [...wishlistMutationKeys.all(), 'logout'] as MutationKey,
};

export const wishlistMutations = (apiOptions: QueryApiOptions) => ({
  wishlistLoginMutation: (
    options: OptionalMutationOptions<undefined, WishlistLoginParams> = {}
  ): UseMutationOptions<undefined, Error, WishlistLoginParams> => ({
    ...options,
    mutationKey: wishlistMutationKeys.login(),
    mutationFn: (params: WishlistLoginParams) => wishlistLogin(apiOptions, params),
  }),
  wishlistLogoutMutation: (
    options: OptionalMutationOptions<undefined, WishlistLogoutParams> = {}
  ): UseMutationOptions<undefined, Error, WishlistLogoutParams> => ({
    ...options,
    mutationKey: wishlistMutationKeys.login(),
    mutationFn: (params: WishlistLogoutParams) => wishlistLogout(apiOptions, params),
  }),
});
